import { useTheme } from "@emotion/react";
import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { Abouts } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";

const AboutUs = ({
  aboutRef
}) => {
  const theme = useTheme();
  
  return (
    <Box
      id="about"
      ref={aboutRef}
      sx={{
        bgcolor: '#ffffff',
        py: { xs: 6, sm: 7, md: 8 }
      }}
    >
      <Container maxWidth="lg">
        {/* Headings */}
        <Typography 
          fontSize={{ xs: 28, sm: 35, md: 40, lg: 45 }} 
          align="center" 
          color={theme.palette.secondary.main} 
          fontWeight="600"
          sx={{ px: { xs: 2, sm: 3, md: 0 } }}
        >
          A smarter way to plan your student’s future
        </Typography>
        <Typography 
          fontSize={{ xs: 28, sm: 35, md: 40, lg: 45 }} 
          align="center" 
          color={theme.palette.secondary.main} 
          fontWeight="600" 
          sx={{ 
            mt: { xs: -0.5, sm: -0.8, md: -1 },
            px: { xs: 2, sm: 3, md: 0 }
          }}
        >
          - with Clarity, Strategy and Confidence.
        </Typography>
        
        {/* Description */}
        <Box sx={{ 
          width: { xs: '95%', sm: '85%', md: '75%', lg: '72%' }, 
          margin: '0 auto',
          mt: { xs: 2, sm: 2.5, md: 3 }
        }}>
          <Typography 
            align="center" 
            fontSize={{ xs: 16, sm: 18, md: 20 }}
            sx={{ px: { xs: 1, sm: 2, md: 0 } }}
          >
            Dream College Planner is designed to support students through every stage of the college journey — bringing together parents, tutors, mentors, and counselors on one unified platform to help students get into their dream college.
          </Typography>
        </Box>
        
        {/* Cards Grid */}
        <Grid 
          container 
          spacing={2}
          sx={{ 
            mt: 2
          }}
        >
          {Abouts.map((a, index) => (
            <Grid 
              item 
              xs={12} 
              sm={6} 
              md={3} 
              key={index}
              sx={{
                display: 'flex',
              }}
            >
              <CommonCard
                paddingBottom="0px"
                borderRadius={1}
                border={`1px solid #EFEFEF`}
                background={theme.palette.background.main}
                sx={{
                  height: '100%', // Ensures card takes full height of grid item
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
                content={
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      height: '100%',
                      minHeight: { xs: '280px', sm: '300px', md: '320px' }, // Consistent minimum height
                    }}
                  >
                    {/* Image with consistent spacing */}
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      mt: 1
                    }}>
                      <img 
                        src={a.image} 
                        alt='about' 
                        style={{
                          height: 'auto',
                          width: 'auto',
                          maxHeight: { xs: '60px', sm: '65px', md: '70px' },
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                    
                    {/* Title with fixed height for consistency */}
                    <Typography 
                      fontWeight={600} 
                      fontSize={{ xs: 20, sm: 22, md: 24 }} 
                      mt={{ xs: 2, md: 1 }} 
                      mb={{ xs: 1, md: 1 }} 
                      color={theme.palette.secondary.main}
                      align="center"
                    >
                      {a.title}
                    </Typography>
                    
                    {/* Subtitle with flexible height but consistent spacing */}
                    <Typography 
                      fontWeight={600} 
                      fontSize={{ xs: 12, sm: 13, md: 14 }} 
                      mb={{ xs: 2, md: 3 }} 
                      textAlign="center" 
                      color={theme.palette.background.dark}
                      sx={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        px: { xs: 1, md: 2 }
                      }}
                    >
                      {a.subtitle}
                    </Typography>
                  </Box>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default AboutUs;